import { formatDeliveryDate } from "../../utils/deliveryDateFormat";

export interface DeliveryTripReportRow {
    idx: number;
    vehicle_plate: string;
    scheduled_at: string;
    delivery_address: string;
    productOrderName: string;
    productCode: string;
    productName: string;
    quantity: number;
}

export const buildDeliveryTripReportRows = (selectedGroups: any[]): DeliveryTripReportRow[] => {
    const rows: DeliveryTripReportRow[] = [];

    (selectedGroups || []).forEach((group: any, groupIndex: number) => {
        (group.product_orders || []).forEach((order: any) => {
            (order.delivery_trips || []).forEach((trip: any) => {
                (trip.delivery_products || []).flatMap((item: any) =>
                    item.delivery_allocations?.length ? item.delivery_allocations.map((allocation: any) => ({...item, ...allocation})) : [item]
                ).forEach((deliveryProduct: any) => {
                    rows.push({
                        idx: groupIndex + 1,
                        vehicle_plate: trip.vehicle_plate || group.vehicle_plate || group.car_plate || "",
                        scheduled_at: trip.scheduled_at
                            ? formatDeliveryDate(trip.scheduled_at)
                            : "",
                        delivery_address: deliveryProduct.delivery_address || trip.delivery_address || "",
                        productOrderName: order.name || "",
                        productCode:
                            deliveryProduct.product?.product_code ||
                            deliveryProduct.material?.material_code ||
                            "N/A",
                        productName:
                            deliveryProduct.product?.name ||
                            deliveryProduct.material?.name ||
                            "N/A",
                        quantity: deliveryProduct.quantity || 0,
                    });
                });
            });
        });
    });

    return rows;
};
